import React from "react";
import "./Exclusive_Gateway_Experiences.css";
import Common_Title from "../../common_component/common_title/Common_Title";
import { useNavigate } from "react-router-dom";

const Exclusive_Gateway_Experiences = ({ locations = [] }) => {
  const navigate = useNavigate();

  const handleNavigate = (continentId) => {
    console.log("Clicked:", continentId);

    navigate(`/location/${continentId}`);
  };

  return (
    <section className="exclusive-section">
      <div className="container">
        <Common_Title title="Exclusive Gateway Experiences" />

        {/* FIRST ROW */}

        <div className="row g-3 mb-3">
          <div className="col-md-5">
            <div className="destination-card">
              <div className="crotia_img_wrapper">
                <img src={locations?.[6]?.image} alt="Europe" />
              </div>

              <span className="destination-name">Europe</span>
            </div>
          </div>

          <div className="col-md-7">
            <div className="destination-card">
              <div className="poland_img_wrapper">
                <img src={locations?.[5]?.image} alt="Asia" />
              </div>

              <span className="destination-name">Asia</span>
            </div>
          </div>
        </div>

        {/* SECOND ROW */}

        <div className="row g-3 position-relative second-row">
          <div className="col-lg-8">
            <div className="row g-3">
              <div className="col-md-6">
                <div className="destination-card">
                  <div className="spain_img_wrapper">
                    <img src={locations?.[4]?.image} alt="North America" />
                  </div>

                  <span className="destination-name">North America</span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="destination-card">
                  <div className="iceland_img_wrapper">
                    <img src={locations?.[3]?.image} alt="South America" />
                  </div>

                  <span className="destination-name">South America</span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="destination-card">
                  <div className="portugal_img_wrapper">
                    <img src={locations?.[2]?.image} alt="Africa" />
                  </div>

                  <span className="destination-name">Africa</span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="destination-card malta-card">
                  <div className="malta_img_wrapper">
                    <img src={locations?.[1]?.image} alt="Australia" />
                  </div>

                  <span className="destination-name">Australia</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 greece-absolute">
            <div className="destination-card full-height-card greece_img">
              <div className="greece_img_wrapper">
                <img src={locations?.[0]?.image} alt="Antarctica" />
              </div>

              <span className="destination-name">Antarctica</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Exclusive_Gateway_Experiences;
